import { actions as commonActions, actionTypes as commonActionTypes } from "@tailormed/common-client/store/action";

const Types = {
  LOGIN_ACTION: "LOGIN_ACTION",
  LOGOUT: "LOGOUT",
  SET_ENVIRONMENT: "SET_ENVIRONMENT",
  SET_USER: "SET_USER",
  SET_NETWORK_ACTION: "SET_NETWORK_ACTION",
  SEARCH_ASSISTANCE_PROGRAM_ACTION: "SEARCH_ASSISTANCE_PROGRAM_ACTION",
  SELECT_ASSISTANCE_PROGRAM_ACTION: "SELECT_ASSISTANCE_PROGRAM_ACTION",
  SET_SHOW_ASSISTANCE_PROGRAM_MODAL: "SET_SHOW_ASSISTANCE_PROGRAM_MODAL",
  SET_SHOW_SUPPORT: "SET_SHOW_SUPPORT",
  SET_ASSISTANCE_PROGRAMS: "SET_ASSISTANCE_PROGRAMS",
  SET_SELECTED_ASSISTANCE_PROGRAM: "SET_SELECTED_ASSISTANCE_PROGRAM",
  CLEAR_ASSISTANCE_PROGRAMS: "CLEAR_ASSISTANCE_PROGRAMS",
  SEND_SUPPORT_TICKET: "SEND_SUPPORT_TICKET",
  SET_IDP_CONFIG: "SET_IDP_CONFIG",
  SET_OKTA_CONFIG: "SET_OKTA_CONFIG",
  SET_NOTIFICATION_PREFERENCES: "SET_NOTIFICATION_PREFERENCES",
  UPDATE_NOTIFICATION_PREFERENCES_ACTION: "UPDATE_NOTIFICATION_PREFERENCES_ACTION",
  ...commonActionTypes
};

const loginAction = (username, password) => ({
  type: Types.LOGIN_ACTION,
  username,
  password
});

const logout = () => ({
  type: Types.LOGOUT
});

const setEnvironment = (environment) => ({
  type: Types.SET_ENVIRONMENT,
  environment
});

const setUser = (user) => ({
  type: Types.SET_USER,
  user
});

const searchAssistanceProgramAction = (searchQuery, filters) => ({
  type: Types.SEARCH_ASSISTANCE_PROGRAM_ACTION,
  searchQuery,
  filters
});

const selectAssistanceProgramAction = (id) => ({
  type: Types.SELECT_ASSISTANCE_PROGRAM_ACTION,
  id
});

const setShowAssistanceProgramModal = (showAssistanceProgramModal) => ({
  type: Types.SET_SHOW_ASSISTANCE_PROGRAM_MODAL,
  showAssistanceProgramModal
});

const setShowSupport = (visible, assistanceProgram) => ({
  type: Types.SET_SHOW_SUPPORT,
  visible,
  assistanceProgram
});

const setAssistancePrograms = (assistancePrograms) => ({
  type: Types.SET_ASSISTANCE_PROGRAMS,
  assistancePrograms
});

const setSelectedAssistanceProgram = (selectedAssistanceProgram) => ({
  type: Types.SET_SELECTED_ASSISTANCE_PROGRAM,
  selectedAssistanceProgram
});

const clearAssistancePrograms = () => ({
  type: Types.CLEAR_ASSISTANCE_PROGRAMS
});

const setNetworkAction = (actionType, isFetching, msg = "", code = undefined) => ({
  type: Types.SET_NETWORK_ACTION,
  actionType,
  isFetching,
  msg,
  code
});

const sentSupportTicketAction = (subject, comment, user) => ({
  type: Types.SEND_SUPPORT_TICKET,
  subject,
  comment,
  user
});

const setIDPConfig = (idpConfig) => ({
  type: Types.SET_IDP_CONFIG,
  idpConfig
});

const setOktaConfig = (oktaClientId) => ({
  type: Types.SET_OKTA_CONFIG,
  oktaClientId
});

const setNotificationPreferences = (notificationPreferences) => ({
  type: Types.SET_NOTIFICATION_PREFERENCES,
  notificationPreferences
});

const updateNotificationPreferencesAction = (preferenceType, targetId, notificationType, isEnabled) => ({
  type: Types.UPDATE_NOTIFICATION_PREFERENCES_ACTION,
  preferenceType,
  targetId,
  notificationType,
  isEnabled
});

export default {
  loginAction,
  logout,
  setEnvironment,
  setUser,
  setNetworkAction,
  sentSupportTicketAction,
  searchAssistanceProgramAction,
  selectAssistanceProgramAction,
  setAssistancePrograms,
  setSelectedAssistanceProgram,
  setShowAssistanceProgramModal,
  setShowSupport,
  clearAssistancePrograms,
  setIDPConfig,
  setOktaConfig,
  setNotificationPreferences,
  updateNotificationPreferencesAction,
  Types,
  ...commonActions
};
